/** Helpers for guest chat conversation-resolved / reopened system messages. */

import { isSystemMessage } from "./verificationMessages";

const textOf = (msg) => String(msg?.text || "");

export const isConversationResolvedMessage = (msg) =>
  isSystemMessage(msg) &&
  /conversation\s+(has\s+been\s+)?resolved/i.test(textOf(msg)) &&
  !/unresolved/i.test(textOf(msg));

export const isConversationReopenedMessage = (msg) =>
  isSystemMessage(msg) &&
  /conversation\s+(has\s+been\s+)?(reopened|unresolved)/i.test(textOf(msg));

/**
 * Resolve/reopen can toggle over time, so look for whichever of the two
 * system messages is most recent — same pattern as blocked/unblocked.
 */
export const getResolvedBannerState = (messages = []) => {
  for (let i = messages.length - 1; i >= 0; i -= 1) {
    const msg = messages[i];
    if (isConversationReopenedMessage(msg)) return null;
    if (isConversationResolvedMessage(msg)) return { type: "resolved" };
  }
  return null;
};
